import React from 'react'
import IndexSignup from '../Components/signup/IndexSignup'

const Signup = () => {
  return (
    <div className='bg-[#f0f2f5] flex min-h-screen'>
      <IndexSignup/>
    </div>
  )
}

export default Signup
